 <template>
	<div class='content'>
		<van-nav-bar
		   title="订单列表"
		   left-text=""
		   right-text=""
		   left-arrow
		   @click-left="onClickLeft"
		  @click-right="onClickRight"
		/>
		<van-cell-group class='box_groupa' style="padding-bottom: 80px;">
			<div v-for="(item,index) in list" :key="index">
				 <van-row  class="box_visita"   >
				  	<van-col span="24" style="width: 100%;margin-left: 0%; margin-bottom: 10px;border: 1px solid gainsboro;border-left: 0px;border-right: 0px;">
		  	  		    <van-col class="list" span="24"  style="border-color: azure; text-align: left;height:33xp;line-height: 33px;border-bottom: 1px solid gainsboro;">
		  	  		  		<van-col span="2" style="margin-top:3px;" >
	  	  		  		 		<van-icon name="bars" color="#4fc08d" />
	  	  		  		 	</van-col>
	  	  		  		 	<van-col span="18">
	  	  		  		 		订单号：{{item.order}}<span v-if="hide">{{item.id}}</span>
	  	  		  		 	</van-col>
		  	  		    </van-col>
		  	  		    
		  	  		    <van-col class="list" span="24"  style="border-color: azure; text-align: left;height:33xp;line-height: 33px;border-bottom: 1px solid gainsboro;"> 
					   		<van-col span="2" style="margin-top:2px;" >
					   			<van-icon name="clock"color="#4fc08d" />
					   		</van-col>	
					   		<van-col span="18">
							    下单时间：{{item.time}}
							</van-col>
					    </van-col>
					    
					    <van-col class="list"  span="24"  style="border-color: azure; text-align: left;height:33xp;line-height: 33px;border-bottom: 1px solid gainsboro;">
					    	<van-col span="2" style="margin-top:2px;" >
					    		<van-icon name="refund-o" />
					    	</van-col>	
					    	<van-col span="18">
								数量：{{item.num}}
								金额：{{item.total}}
								次数/时间：{{item.remainTimes}}
							</van-col>	
					    </van-col>
					    <van-col class="list" @click="ticketlist(index)" span="24"  style="border-color: azure; text-align: left;height:33xp;line-height: 33px;border-bottom: 1px solid gainsboro;">
					   	   	<van-col span="2" style="margin-top:2px;" >
					   	   		<van-icon name="coupon-o" />
					   	   	</van-col>	
					   	   	<van-col span="18" style="color:#00BFFF;">
							查看门票详情信息 
							</van-col>	
							<van-col span="2" style="padding-top:4px;" >
							  <van-icon name="arrow"  size="18" color="#1989fa"/> 
							</van-col>	
						</van-col>
			 		    <van-col  class="list" @click="ticketQR(index)"  span="24" style="border-color: azure; text-align: left;height:33xp;line-height: 33px;border-bottom: 0px solid gainsboro;">
					   	  	<van-col span="2" style="margin-top:2px;" >
					   	   		<van-icon name="qr" />
					   	   	</van-col>	
					   	   	<van-col span="18" style="color: red;" >
							查看通行的二维码 
							</van-col>	
							<van-col span="2" style="padding-top:4px;">
							  <van-icon name="arrow"  size="18" color="#1989fa"/> 
							</van-col>	
						</van-col>
				    </van-col>
			    </van-row>
				
			</div>
		</van-cell-group>	
	    <van-tabbar v-model="active">
			    <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
				<van-tabbar-item icon="setting-o"  @click="user()">个人中心</van-tabbar-item>
		</van-tabbar>
		
	</div>
</template>

<script>
  export default {
  data () {
    return {
    	 active:1,
    	 order:'',
    	 total:"",
    	 numlist:'',
    	 timeDate:'',
    	 currentDate: new Date(),
    	 phone:'',
   	     text: '',
	     message:'',
	     isLoadingShow: true,
    	 hide:false,
        
	     finished: false,
         show: false,
         className: '',
         showCalendar: false,
         list:[]
	    }
    },
    mounted(){
    	//this.time();
    	this.orderlist();
    },
	methods: {
		orderlist(){
			const loading = this.$loading({
		          lock: true,
		          text: 'Loading',
		          spinner: 'el-icon-loading',
		          background: 'rgba(0, 0, 0, 0.4)'
		        });
			let storage=window.sessionStorage;
    		let openid = storage.getItem("openid")
			this.$axios({
					url: "/api/order/wxOrderList",
					method: "get",
					params: {
						openid: openid,
					}
				})
			.then(res => {
				 setTimeout(() => {
				     loading.close()//关闭 Loading 加载
				    }, 800)
				var data = res.data[0];
				 console.log(data)
			    for (const i in data) {
		           this.list.push({
			        	  order:data[i].orderID,
				          time:data[i].orderTime,
				          num:data[i].ticketNum,
				          total:data[i].orderAmount,
				    	  remainTimes:data[i].remainTimes,
				    	  
			         });
		      
		       
		      }
			 })
				.catch(err => {
					  setTimeout(() => {
				     loading.close()//关闭 Loading 加载
				    }, 800)
				console.log(err);
			});
		
		},
		
		ticketlist(index){
			 let order = this.list[index].order;
			 let total = this.list[index].total;
			 this.$router.push({ path: "/mn_ticketOrderTicket",query: { order: order,total:total}});
		},
		ticketQR(index){
			 let order = this.list[index].order;
			 this.$router.push({ path: "/mn_ticketOrderQR",query: { order: order }});
		},
		 home(){
	    	 this.$router.push({ path: "/mn_ticketIndex" });
	    },
	    user(){
	    	 this.$router.push({ path: "/mn_ticketUser" });
	    },
		onLoad() {
	        this.loading = false;
			this.finished = true;
	       
	    },
	    onClickLeft(){
	    	this.$router.go(-1);//返回上一层
			//this.$router.push({ path: "/wx_ticketUser",query: { total: total , numlist: numlist }  });
		},
		onClickRight(){
			
		},
			// 选项格式化函数
		onSubmit(){
		 	
		 },
        time(){
		      this.timeDate=this.dateFormat();
		      this.total = this.$route.query.total;
		      this.numlist= this.$route.query.numlist;
		    
		    },
		onConfirm(date) {
		 	  this.timeDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
		      this.showCalendar = false;
		    },    
		dateFormat() {//获取当前时间
		        var date=new Date();
		        var year=date.getFullYear();
		        var month= date.getMonth()+1<10 ? +(date.getMonth()+1) : date.getMonth()+1;
		        var day=date.getDate()<10 ? +date.getDate() : date.getDate();
		        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
		        //var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
		        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
		        return year+"-"+month+"-"+day
            },   
      /*  showPopup () {
	        this.show = true
	        this.isLoadingShow = true
	        setTimeout(() => {
	           this.isLoadingShow = false
	        }, 500)
        },*/
        
        
       
		 
	}
}
</script>

<style scoped>
 
	
	.box_visita .list i {
		color: #00B2AD;
		width: 20px;
		height: 20px;
		font-size: 15px;
		
		margin-left: 10px;
	}
	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	.box_visit .check{
		text-align: right !important;
	}
    .box_visit  .check i {
		margin-left: 0px !important;
		margin-right: 8px !important;
		margin-top:10px;
	}
	.check_code{
		display:inline-block;	
		width: 80px;
		height: 33px;
		position: relative;
		top: -2.5px;
		}
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}
	
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlistmini/mn_ticketOrderlist.vue